import { initCarousel } from "../../carousel";
import { initImagesFadeshow } from "../../imagesFadeshow";

document.addEventListener("DOMContentLoaded", () => {
  initImagesFadeshow("fadeshow-hero");
  initCarousel("carousel-testimonials");
});
